module.exports = __webpack_public_path__ + "img/background.3fcdf438.jpg";